"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("./Flex.js"));

var _Navigator = _interopRequireDefault(require("../App/Navigator.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardModule = _interopRequireDefault(require("./Card.module.scss"));

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstraction of Material UI's `Card`
 */
class Card extends _react.default.PureComponent {
  /**
   * Clicked.
   *
   * @return {void}
   */
  handleClick = () => {
    const uri = this.props.uri;
    if (uri) _Navigator.default.navigate(uri);else this.props.onClick?.(this.props.value, this.props.name);
  };
  /**
   * Render.
   * 
   * @return {ReactNode}
   */

  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Card, {
      className: this.props.className,
      elevation: this.props.elevation,
      raised: this.props.raised,
      square: this.props.square,
      variant: this.props.outlined ? "outlined" : undefined,
      children: this.hasAction ? this.renderActionArea() : this.renderContent()
    });
  }
  /**
   * Render the action area.
   *
   * @return {ReactNode}
   */


  renderActionArea() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.CardActionArea, {
      className: `${_CardModule.default.contentArea} ${this.props.classNameActionArea || ""}`.trim(),
      disabled: this.props.disabled,
      onClick: this.handleClick,
      children: this.renderContent()
    });
  }
  /**
   * Render the card content.
   * 
   * @return {ReactNode}
   */


  renderContent() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      className: `${_CardModule.default.contentArea} ${this.props.classNameFlex || ""}`.trim(),
      gap: this.props.gap,
      px: this.props.px,
      py: this.props.py,
      ...this.props.FlexProps,
      children: this.props.children
    });
  }
  /**
   * Get whether we have a click action.
   * 
   * @return {Boolean}
   */


  get hasAction() {
    return !!(this.props.onClick || this.props.uri);
  }

  static propTypes = {
    FlexProps: _propTypes.default.object,
    children: _propTypes.default.node,
    className: _propTypes.default.string,
    classNameActionArea: _propTypes.default.string,
    classNameFlex: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    elevation: _propTypes.default.number,
    gap: _propTypes.default.number,
    name: _propTypes.default.string,
    onClick: _propTypes.default.func,
    outlined: _propTypes.default.bool,
    px: _propTypes.default.number,
    py: _propTypes.default.number,
    raised: _propTypes.default.bool,
    square: _propTypes.default.bool,
    uri: _propTypes.default.string,
    value: _propTypes.default.any
  };
  static defaultProps = {
    disabled: false,
    elevation: 1,
    gap: 1,
    outlined: false,
    px: 1,
    py: 1,
    raised: false,
    square: false
  };
}

var _default = Card;
exports.default = _default;